import ZoneTablesQR from "@/views/admin/qr/ZoneTablesQR";

export default {
  path: "tables-qr/zones",
  name: "ZoneTablesQR",
  component: ZoneTablesQR,
  props: true,
  meta: {
    requiresAuth: true
  }
};
